// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  //API_Base_URL: 'http://localhost:32973/api/',
  //API_Base_URL: 'http://106.51.65.164:8097/api/',
  //API_Base_URL: 'http://192.168.1.252:8041/api/',
  //API_Base_URL: 'http://192.168.1.8:8082/api/',
  //API_Base_URL: 'http://telemedicinephcapi.esdinfra.com/api/'
  API_Base_URL: 'http://telemedicinepvtapi.esdinfra.com/api/'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
